/** RMS речи у микрофона — около 0,05…0,2: шкала индикаторов растянута, чтобы обычная речь доходила до верха. */
export const VOICE_LEVEL_SCALE = 6;

/** Уровень микрофона (RMS 0…1) — доля шкалы индикатора 0…1. */
export const scaledVoiceLevel = (level: number) => Math.min(1, Math.max(0, level * VOICE_LEVEL_SCALE));

/** Уровень своего микрофона несколько раз в секунду — мимо состояния: перерисовывается только индикатор. */
export interface IVoiceLevelSource {
    get: () => number;
    subscribe: (listener: () => void) => () => void;
}
